import styled from "styled-components";
import LinkHandler from "./../LinkHandler";

const StyledImageContainerLink = styled(LinkHandler)`
  display: block;
  position: relative;
`;

const StyledImageContainer = styled.div`
  display: block;
  position: relative;
`;

const StyledImg = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
`;

const StyledButton = styled.div`
  position: relative;
`;

export {
  StyledImageContainer,
  StyledImageContainerLink,
  StyledImg,
  StyledButton
};
